<div v-bind:class="getClassName">
  {{getNetworkMessage}}
</div>
